var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSMallBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 171,
    height: 186,
    viewBox: "0 0 171 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:none;stroke:#4b4b4b;stroke-miterlimit:10;stroke-width:3px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sMall_building",
    transform: "translate(-724 -329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_808",
    fill: "none",
    d: "M0 0H171V186H0z",
    transform: "translate(724 329)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    transform: "translate(773 403.717)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_760",
    width: 71.929,
    height: 105.426,
    className: "cls-2",
    rx: 10.504
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_761",
    width: 19.745,
    height: 19.745,
    className: "cls-2",
    rx: 2.382,
    transform: "translate(26.092 85.68)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_762",
    width: 19.745,
    height: 19.745,
    className: "cls-2",
    rx: 2.382,
    transform: "translate(11.459 41.606)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_763",
    width: 19.745,
    height: 19.745,
    className: "cls-2",
    rx: 2.382,
    transform: "translate(40.372 41.606)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_764",
    width: 19.745,
    height: 19.745,
    className: "cls-2",
    rx: 2.382,
    transform: "translate(11.459 13.399)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_765",
    width: 19.745,
    height: 19.745,
    className: "cls-2",
    rx: 2.382,
    transform: "translate(40.372 13.399)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSMallBuilding);
export default __webpack_public_path__ + "static/media/s-mall-building.dd6bc9cdf59ad160bf1a4929a7dd0102.svg";
export { ForwardRef as ReactComponent };